import React from 'react';
import { asBlob } from 'html-docx-js-typescript';

const DownloadDocxButton = ({ input }) => {
  const downloadDocx = () => {
    // Convert HTML string to Blob (DOCX)
    const htmlContent = `<!DOCTYPE html><html><head><meta charset="UTF-8"></head><body>${input}</body></html>`;
    console.log(htmlContent);
    asBlob(htmlContent).then(blob => {
      // Create a URL for the blob
      const url = window.URL.createObjectURL(blob);

      // Create a temporary anchor element and trigger download
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = 'document.docx';
      document.body.appendChild(anchor);
      anchor.click();

      // Clean up
      document.body.removeChild(anchor);
      window.URL.revokeObjectURL(url);
    });
  };

  return <button className='content-button status-button open' onClick={downloadDocx}>Download as DOCX</button>;
};

export default DownloadDocxButton;
